module.exports = __webpack_public_path__ + "img/header-phone.54afa1ef.jpg";